// functions/iban.ts
import { ValidationError } from "../errors/ValidationError.js";
import "../validator.js";
var COUNTRY_CODES_LENGHT = {
  AL: 28,
  AD: 24,
  AT: 20,
  AZ: 28,
  BH: 22,
  BY: 28,
  BE: 16,
  BA: 20,
  BR: 29,
  BG: 22,
  BI: 27,
  CR: 22,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  DJ: 27,
  DO: 28,
  EG: 29,
  SV: 28,
  EE: 20,
  FK: 18,
  FO: 18,
  FI: 18,
  FR: 27,
  GE: 22,
  DE: 22,
  GI: 23,
  GR: 27,
  GL: 18,
  GT: 28,
  VA: 22,
  HU: 28,
  IS: 26,
  IQ: 23,
  IE: 22,
  IL: 23,
  IT: 27,
  JO: 30,
  KZ: 20,
  XK: 20,
  KW: 30,
  LV: 21,
  LB: 28,
  LY: 25,
  LI: 21,
  LT: 20,
  LU: 20,
  MT: 31,
  MR: 27,
  MU: 30,
  MD: 24,
  MC: 27,
  MN: 20,
  ME: 22,
  NL: 18,
  NI: 28,
  MK: 19,
  NO: 15,
  PK: 24,
  PS: 29,
  PL: 28,
  PT: 25,
  QA: 29,
  RO: 24,
  RU: 33,
  LC: 32,
  SM: 27,
  ST: 25,
  SA: 24,
  RS: 22,
  SC: 31,
  SK: 24,
  SI: 19,
  SO: 23,
  ES: 24,
  SD: 18,
  SE: 24,
  CH: 21,
  TL: 23,
  TN: 24,
  TR: 26,
  UA: 29,
  AE: 23,
  GB: 22,
  VG: 24
};
function validateIban(iban2) {
  iban2 = iban2.replace(/[^A-Z0-9]+/gi, "").toUpperCase();
  const contry = iban2.substring(0, 2);
  if (contry && contry in COUNTRY_CODES_LENGHT) {
    const len = COUNTRY_CODES_LENGHT[contry];
    if (len !== iban2.length)
      return false;
  } else {
    return false;
  }
  if (!/^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/.test(
    iban2
  ))
    return false;
  const deconstructedIban = iban2.match(/^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$/);
  if (!deconstructedIban || deconstructedIban.length !== 4 || !deconstructedIban[1] || !deconstructedIban[2] || !deconstructedIban[3])
    return false;
  const numbericed = (deconstructedIban[3] + deconstructedIban[1] + deconstructedIban[2]).replace(
    /[A-Z]/g,
    function(ch) {
      return (ch.charCodeAt(0) - 55).toString();
    }
  );
  const mod97 = numbericed.match(/\d{1,7}/g)?.reduce(function(total, curr) {
    return Number(total + curr) % 97;
  }, 0);
  return mod97 === 1;
}
var iban = ({ translationKey = "validation_iban", allowEmpty = false } = {}) => (options) => {
  if (!options.value && allowEmpty)
    return;
  if (typeof options.value === "string" && validateIban(options.value))
    return;
  throw new ValidationError(`Key ${options.key} is not a valid iban!`, { key: options.key, translationKey });
};
export {
  iban,
  validateIban
};
